<!-- 首页版块宣传纪念出版列表组件 -->
<template>
  <div class="books-block-wrap">    
    <BlockName 
      blockName="研究出版"
      url="/xuanchuan?tab=yanjiuchuban"></BlockName>

      <swiper class="book-swiper" ref="bookswiper" :options="swiperOption">
          <swiper-slide v-for="item in bookList"
            class="book-swiper-slide"
            :key="item.id">
            <div class="book-wrap" @click="handleClickBook">
                <div class="book-info">
                    <div class="cover-box">
                      <el-image
                            class="cover-img"
                            style="width:auto; height: 100%;"                            
                            :src="item.image"
                            fit="retain"></el-image>
                      </div>
                    <div class="title">
                      <span>{{ item.title }}</span>
                    </div>
                </div>
            </div>
          </swiper-slide>
          
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          
      </swiper>

  </div>
</template>

<script>
  import BlockName from './blockname.vue';
  import "swiper/dist/css/swiper.css";
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import {getBookList, getChannelArticleList} from "@/api/content";


  export default {
    components: {BlockName, swiper, swiperSlide },
    props: {

    },
    data() {
        return {
          swiperOption: {
              slidesPerView: 'auto',
              spaceBetween: 0,
              direction: 'horizontal',
              centerInsufficientSlides: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }
            },
          channelAlias: 'yanjiuchuban',
          bookList:[],
        };
      },
    methods: {
      getArticleList(){
          let queryParam = {
              channelId: 0,
              channelAlias: this.channelAlias,
              parentAlias: null,
              page: this.currPage,
              limit: 500,
              manualSort: true,
          };
          getChannelArticleList(queryParam).then(result => {                    
              if(result.code == 0 && result.data != null){
                  this.bookList = result.data.list;   
              }else{
                  this.bookList = [];
              }    
          });
      },

      handleClickBook(){        
        let routeData = this.$router.resolve({ path: '/xuanchuan?tab=yanjiuchuban'});
        window.open(routeData.href, '_blank');
      }
    },
    created() {
      this.getArticleList();
    },
    mounted() {}
  };
</script>

<style scoped>
.books-block-wrap{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  padding: 0px 24px 0px 24px;
  gap: 20px;
  flex-grow: 1;
  background: #FFFFFF;
  box-sizing: border-box;
}

.book-swiper{
  width: 100%;
  height: 240px;
  padding: 30px 0px;
  background: #ffffff;
}
.book-swiper-slide{
  width: 195px;
  height: 240px;
}
.data-list{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  padding: 40px;
  gap: 20px;
  box-sizing: border-box;
}

.book-wrap{
  height: 100%;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-between;

}

.book-info{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  border: 1px solid #D8DCE2;
  padding: 10px;  
  overflow: hidden;
  margin: 10px;
  height: 100%;
}
.cover-box{
  overflow: hidden;
  flex-grow: 1;
}
.cover-img{
  transition:all 0.35s ease-in-out;
  overflow: hidden;
  cursor: pointer;
}
.cover-img:hover{
  transform: scale(1.1);
  overflow: hidden;
}
.book-info .title{
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;
  color: #000000;
  height: 48px;
  cursor: pointer;
}

@media screen and (max-width: 1000px){
  .books-block-wrap{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    padding: 0px 10px;
    gap: 12px;   
    background: #D8DCE2;
  }
  
  .book-swiper{    
    padding: 12px 0px;
    background: #ffffff;
    height: 192px;
  }
  .book-swiper-slide{
    width: 154px;
    height: 192px;
  } 
  
}

@media screen and (max-width: 600px){
  .book-info{
    margin: 10px 0;
  }

}

@media screen and (max-width: 760px){  
  .swiper-button-next, .swiper-button-prev{
    display: none;
  }
 }
</style>



// WEBPACK FOOTER //
// src/components/blocks/memoryblock/booksblock.vue